<template>
  <div class="h-full pb-6">
    <div v-if="dataAvailable && loaded" class="w-full ">
      <div class="divide-y divide-gray-300 h-full w-full ">
        <table class="divide-y divide-gray-300 w-full mt-2">
          <thead>
            <tr class="flex flex-row px-4 ">
              <th class="text-left text-l w-1/2 font-semibold text-gray-900">{{ $t('widget.topClients.tableTitle') }}</th>

              <th v-if="filter === 'logins'" class="text-right text-l w-1/2 font-semibold text-gray-900 ">{{ $t('widget.filters.logins') }}</th>
              <th v-if="filter === 'sales'" class="text-right text-l w-1/2 font-semibold text-gray-900 ">{{ $t('widget.filters.sales') }}</th>
              <th v-if="filter === 'orders'" class="text-right text-l w-1/2 font-semibold text-gray-900 ">{{ $t('widget.filters.orders') }}</th>
            </tr>
          </thead>
          <tbody  :class=" hasLongTitle? 'divide-y divide-gray-200 h-32rem flex flex-col overflow-y-auto ': 'divide-y divide-gray-200 flex flex-col overflow-y-auto' + pillMargin">
            <table-item v-for="(item, index) in items"
                        :key="item.id"
                        :value="numbers[index].toString()"
                        :name="item.name"
                        :info="item.info"
                        :hasInfo="hasInfo"
                        :hasScrollBar="items.length > 9"
            ></table-item>
          </tbody>
        </table>
<!--        <div v-if="dataAvailable && loaded" class="text-center px-3 pt-1.5 text-sm flex flex-col justify-end bottom-0">-->
<!--          <a :href="[infoUrl]" class=" moreInfoUrl ">{{ $t('widget.moreInfo') }}</a>-->
<!--        </div>-->
      </div>
    </div>
    <div v-if="!loaded" class="flex h-full items-center justify-center">
      <div class="loader loader--style3">
        <svg id="loader-1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px" width="80px" height="80px" viewBox="0 0 50 50"  xml:space="preserve">
          <path class="loadingSpinner h-20" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z">
            <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="1s" repeatCount="indefinite"/>
            </path>
          </svg>
      </div>
    </div>
    <div v-if="!dataAvailable && loaded" class="h-full flex justify-center">
      <p  v-if="filter === 'logins'" class="self-center px-4 text-center -mt-14">{{ $t('widget.noDataForPill', {pill: $t('widget.filters.logins').toLowerCase()}) }}</p>
      <p  v-if="filter === 'sales'" class="self-center px-4 text-center -mt-14">{{ $t('widget.noDataForPill', {pill: $t('widget.filters.sales').toLowerCase()}) }}</p>
      <p  v-if="filter === 'orders'" class="self-center px-4 text-center -mt-14">{{ $t('widget.noDataForPill', {pill: $t('widget.filters.orders').toLowerCase()}) }}</p>
    </div>
  </div>
</template>

<script setup>
import {defineProps, onMounted, ref, watch, defineEmits} from "vue";
import TableItem from "@/widgetContent/listItems/TableItem";
import ApiService from "@/services/ApiService";
import {useApiStore} from "@/stores/ApiStore";
const Key = useApiStore();

let apiService = new ApiService;

let props = defineProps({
  update: Number,
  source: String,
  style: Object,
  colorPalette: Object,
  pills: Array,
  type: String,
  hasLongTitle: Boolean
})
let filter = ref("")
let items = ref([]);
let hasInfo = ref(false);
let infoUrl = ref(null);
let isCurrency = ref(false);
let numbers = ref(Array);
let dataAvailable = ref();
let loaded = ref(false);
let pillMargin = ref(" h-[29.75rem]")
const emit = defineEmits(["dataLoaded", "dataUnloaded"])

onMounted ( async () => {
  if (props.pills.length <2){
    pillMargin.value = " h-[32.25rem]"
  }
  isCurrency.value = props.source.slice(-5) === "sales";
  await getData(props.source, isCurrency)
  }
)

watch(() => [props.update, props.source], async () => {
  emit("dataUnloaded")
  loaded.value = false;
  isCurrency.value = props.source.slice(-5) === "sales";
  await getData(props.source, isCurrency);
})



async function getData(url, isCurrency) {
  loaded.value = false;
  items.value = [];
  let apiData = await apiService.get(url);
  filter.value = url.substring(url.lastIndexOf('/')+1)
  emit("dataLoaded");
  items.value = apiData.data.dataSet;
  numbers.value = [];
  if (! items.value.length > 0){
    dataAvailable.value = false
  } else {
    dataAvailable.value = true;
    items.value.forEach(entry => {
      if (isCurrency.value)
      {
        numbers.value.push(formatter.format(parseInt(entry.value)/100));
      }
      else
      {
        numbers.value.push(entry.value);
      }
    })
    hasInfo.value = apiData.data.hasInfo
    infoUrl.value = apiData.moreInfoUrl;
  }
  loaded.value = true;
}

const formatter = new Intl.NumberFormat(Key.getLang, {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2
});

</script>